import { render, staticRenderFns } from "./FeaturedBots.vue?vue&type=template&id=77869fbe&scoped=true&"
import script from "./FeaturedBots.vue?vue&type=script&lang=js&"
export * from "./FeaturedBots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77869fbe",
  null
  
)

export default component.exports